import { SessionAnalysisTypeUtils } from '../types/SessionAnalysisType';

// What the session + config-letter picker (components/SessionConfigPicker)
// offers and how it labels it. Kept apart from the component so the callers
// that word their own feedback ("Import 2 runs into A - Baseline") use the
// same labels the dropdowns show.

/** Sessions a run can be placed in (see `isMoveTarget`), newest first. */
export function destinationSessions(sessions?: any[] | null): any[] {
  return (sessions ?? [])
    .filter((s: any) => SessionAnalysisTypeUtils.isMoveTarget(s.analysis_type))
    .sort((a: any, b: any) => new Date(b.date || '').getTime() - new Date(a.date || '').getTime());
}

// "YYYY-MM-DD Description" — the list is sorted by date, so the date has to be
// on the row for the ordering to read as deliberate. `date` arrives as a plain
// ISO date string; slice guards against a datetime ever being sent instead.
export function sessionOptionLabel(s: any): string {
  return s.date ? `${String(s.date).slice(0, 10)} ${s.description}` : s.description;
}

export function configOptionLabel(c: any): string {
  return `${c.letter} - ${c.description}`;
}

/** A session's baseline (letter A) — the config a newly picked session starts on. */
export function baselineConfig(session: any): any | null {
  return session?.configs?.find((c: any) => c.letter === 'A' || c.letter_number === 0) ?? null;
}

export interface SessionConfigChoice {
  session: any | null;
  config: any | null;
}
